import { useCallback, useEffect, useState } from 'react'

const BINDING_MANAGEMENT_DISCLAIMER_VISITED_KEY = '_hp_binding_management_disclaimer_visited'

export const useBindingManagementState = () => {
  const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(true)

  const toggleDisclaimer = useCallback(() => {
    setIsDisclaimerExpanded((prevState) => !prevState)

    if (!localStorage.getItem(BINDING_MANAGEMENT_DISCLAIMER_VISITED_KEY)) {
      localStorage.setItem(BINDING_MANAGEMENT_DISCLAIMER_VISITED_KEY, '1')
    }
  }, [])

  useEffect(() => {
    const hasVisited = localStorage.getItem(BINDING_MANAGEMENT_DISCLAIMER_VISITED_KEY) !== null
    setIsDisclaimerExpanded(!hasVisited)
  }, [])

  return {
    isDisclaimerExpanded,
    toggleDisclaimer,
  }
}
